import { render } from "./VueExcelColumn.vue?vue&type=template&id=640efdca"
import script from "./VueExcelColumn.vue?vue&type=script&lang=js"
export * from "./VueExcelColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__